<template>
	<div v-if="hasStay && arrangement" ref="root" class="scroll-mt-sticky-header">
		<div class="flex items-start justify-between gap-2">
			<span class="flex flex-wrap items-center gap-1 text-sm font-semibold text-ink">
				{{ arrangement.name }}
				<ExtraNightInfoTip />
			</span>
			<PriceText
				:value="arrangement.price"
				:affix="t('per_person_short')"
				affix-class=""
				class="flex-none text-sm font-semibold text-ink"
			/>
		</div>
		<ExtraNightPricing v-if="hasBreakdown" default-open />
	</div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFlowStore } from '@/stores/useFlowStore';
import { useExtraNightPricing } from '@/composables/useExtraNightPricing';
import ExtraNightInfoTip from '@/components/receipt/ExtraNightInfoTip.vue';
import ExtraNightPricing from '@/components/receipt/ExtraNightPricing.vue';
import PriceText from '@/components/PriceText.vue';

const { t } = useI18n();
const flowStore = useFlowStore();
const { hasStay, hasBreakdown } = useExtraNightPricing();

// Every guest carries the same arrangement, so the first receipt line names and prices it.
const arrangement = computed(() => {
  const person = flowStore.checkout.meta?.receipt?.persons?.[0];

  return person?.items.find((item) => item.slot === 'main.product');
});

const root = ref<HTMLElement | null>(null);

function scrollIntoView() {
  const element = root.value;

  if (!element || element.offsetParent === null) return;

  try {
    element.scrollIntoView({behavior: 'smooth', block: 'start'});
  } catch {
    // In environments without smooth scroll support
    element.scrollIntoView(true);
  }
}

defineExpose({scrollIntoView});
</script>
